<style lang="scss" scoped>
@import "./subject";

.my {
  @include my-context-style;

  & &__score {
    &__value {
      font-size: inherit!important;
      color: $color-muted!important;
    }
  }
}
.dn-child-subject {
  &.my {
    .my {
      &__name {
        justify-content: flex-end;
        padding-right: 10px;
      }

      &__input-score {
        margin-left: calc(#{$select-type-width} + #{$detail-column-margin-pc});

        @include mq(sp) {
          margin-left: calc(#{$select-type-width} + #{$detail-column-margin-sp});
        }
      }
    }
  }
}
</style>



<template>
  <dl class="my" :class="[classes, {'dn-child-subject' : !$store.getters['config/isManabi']}]" :id="`subject-${id}`">
    <template v-if="$store.getters['config/isManabi']">
      <dt class="my__name">{{name}}</dt>
      <dd class="my__detail">
        <form class="my__detail__column my__input-score" @submit.prevent="onSubmitDirectScore">
          <input
            v-model="inputDirectScore"
            v-number-range
            type="tel"
            number
            min="0"
            :max="max"
            :disabled="!selected"
          >
          点
        </form>
        <div class="my__detail__column my__score">
          <span
            class="my__score__value"
            :class="{
              'my__score__value--has': hasScore,
              'my__score__value--active': hasScore && selected,
            }"
          >{{hasScore ? score : '---'}}</span>/<span class="my__score__max">{{max}}点</span>
        </div>
      </dd>
    </template>
    <template v-else>
    <dt class="my__name">{{name}}</dt>
    <dd class="my__detail">
      <form class="my__detail__column my__input-score" v-if="isDirect" @submit.prevent="onSubmitDirectScore">
        <input
          v-model="inputDirectScore"
          v-number-range
          type="tel"
          number
          min="0"
          :max="max"
          :disabled="!selected"
        >
        点
      </form>
      <div class="my__detail__column my__score">
        <span
          class="my__score__value"
          :class="{
            'my__score__value--has': hasScore,
            'my__score__value--active': hasScore && selected,
          }"
        >{{hasScore ? score + '点' : '---'}}</span>
        <span class="my__score__separator">/</span>
        <span class="my__score__max">{{max}}点</span>
      </div>
    </dd>
    </template>
  </dl>
</template>



<script>
export default {
  props: {
    value: String,
    id: {
      type: String,
      required: true,
    },
    type: String,
    selected: Boolean,
    fixed: Boolean,
    directScoreBucket: {
      type: Object,
      default: () => { return {} },
    },
    directScoreChangesBucket: {
      type: Array,
      default: () => [],
    },
  },

  inject: ['resetCaliculateState'],

  data() {
    return {
      innerDirectScore: null,
    }
  },

  computed: {
    inputDirectScore: {
      get() { return this.innerDirectScore },
      set(val) {
        if (val === '' || val === null || val === undefined) {
          val = null;
        } else {
          val = parseFloat(val);
        }
        this.innerDirectScore = val;
      },
    },

    classes() {
      return {
        my: true,
        [`my--${this.type}`]: true,
        'my--selected': this.selected,
        'my--fixed': this.fixed,
      }
    },

    data() { return this.$store.getters['selfcheck/subjectOrChildById'](this.id) },
    name() { return this.data.name },
    max() { return this.data.max },
    isDirect() { return this.type === 'direct' },
    history() { return this.$store.getters['selfcheck/subjectHistory'](this.id) },
    hasScore() { return this.history.hasScore },
    score() { return this.history.score },
    selfcheckScore() { return this.history.selfcheckScore },
    directScore() { return this.history.directScore },
    directScoreIsUpdated() { return this.inputDirectScore !== this.directScore },
  },

  watch: {
    innerDirectScore(val) {
      const bucket = Object.assign({}, this.directScoreBucket, {[this.id]: val});
      this.$emit('updateDirectScoreBucket', bucket);
      this.resetCaliculateState && this.resetCaliculateState();
    },

    directScore(val) {
      if (val !== this.innerDirectScore) this.innerDirectScore = val;
    },

    directScoreIsUpdated(val) {
      const bucket = this.directScoreChangesBucket.slice();
      if (val) {
        if (!bucket.includes(this.id)) bucket.push(this.id);
      } else {
        const index = bucket.indexOf(this.id);
        if (index !== -1) bucket.splice(index, 1);
      }
      this.$emit('updateDirectScoreChangesBucket', bucket);
    },
  },

  methods: {
    restoreDirectScore() {
      this.inputDirectScore = this.directScore;
    },

    onSubmitDirectScore() {
      this.$emit('submit-directscore');
    },
  },

  created() {
    this.restoreDirectScore();
  },
}
</script>



// WEBPACK FOOTER //
// ChildSubject.vue?9efb1830